export default {
  tip_client_label: 'Client type',
  tip_client_casnic: 'household',
  tip_client_non_casnic: 'non-household',
  tip_client_rule_required: 'Type of customer is required.',
  tip_client_rule_in: 'Client type is invalid',

  modalitate_racordare_label: 'Connection type',
  modalitate_racordare_sistem_distributie: 'Distribution system',
  modalitate_racordare_sistem_transport: 'Transport system',
  modalitate_racordare_amonte: 'Upstream feed pipe',
  modalitate_racordare_rule_required: 'Connection mode is mandatory.',
  modalitate_racordare_rule_in: 'Connection mode is invalid.',

  transee_de_consum_label: 'Annual consumption category',
  transee_de_consum_no_data: 'First choose how to connect',
  transee_de_consum_a1: 'up to 28.000 MWh / year',
  transee_de_consum_a2: 'over 28.000 MWh / year',
  transee_de_consum_b1: 'up to 280 MWh / year',
  transee_de_consum_b2: 'between 281 MWh and 2800 MWh / year',
  transee_de_consum_b3: 'between 2801 MWh and 28000 MWh / year',
  transee_de_consum_b4: 'between 28001 MWh and 280 000 MWh / year',
  transee_de_consum_b5: 'over 280 000 MWh / year',
  transee_de_consum_rule_required: 'Annual consumption is mandatory.',
  transee_de_consum_rule_in: 'The connection method is invalid.',

  judet_label: 'County',
  judet_rule_required: 'The county is obligatory.',

  localitate_label: 'Town',
  localitate_no_data_label: 'First choose the county',
  localitate_rule_required: 'Town is mandatory.',

  tip_pret_unitar_label: 'The unit price type',
  tip_pret_unitar_cu_reglementate: 'With regulated services included',
  tip_pret_unitar_fara_reglementate: 'No regulated services included',
  tip_pret_unitar_rule_required: 'The unit price type is required.',
  tip_pret_unitar_rule_in: 'The unit price type is invalid.',

  mai_multe_label: 'Add multiple selection criteria',

  termen_plata_label: 'Payment deadline',
  termen_de_plata_oricare: 'Any',
  termen_de_plata_pana_15: 'less than or equal to 15 days',
  termen_de_plata_15_30: 'between 16 and 29 days',
  termen_de_plata_peste_30: 'greater than or equal to 30 days',
  termen_plata_rule_in: 'Payment term invalid.',

  mod_transmitere_factura_oricare: 'Any',
  mod_transmitere_factura_tiparita: 'invoice printed',
  mod_transmitere_factura_electronica: 'electronic invoice',
  mod_transmitere_factura_rule_in: 'The connection method is invalid.',

  durata_contractului_label: 'Contract duration',
  durata_contractului_oricare: 'Any',
  durata_contractului_nedeterminata: 'indefinitely',
  durata_contractului_6: 'shorter than 12 months',
  durata_contractului_12: '12 months',
  durata_contractului_24: 'between 13 and 24 months',
  durata_contractului_36: 'longer than 24 months',
  durata_contractului_rule_in: 'Contract duration is invalid.',

  garantii_label: 'Guarantees',
  garantii_oricare: 'Any',
  garantii_cu_garantii: 'with guarantees',
  garantii_fara_garantii: 'without guarantees',
  garantii_rule_in: 'The guarantee is invalid.',

  si_mai_multe_label: 'Comparison data',

  unitate_de_consum_label: 'Consumption unit',
  unitate_de_consum_hint: 'Change between KWh and MWh',

  consum_mwh_label: 'Estimated annual consumption',
  consum_mwh_rule_required_with: 'Estimated annual consumption is mandatory if the current contract price is specified.',
  consum_mwh_rule_number: 'Estimated annual consumption to be positive.',

  pret_furnizare_mwh_label: 'The current price',
  pret_furnizare_mwh_hint: 'of supply from the current contract without VAT and excise',
  pret_furnizare_mwh_rule_required_with: 'The price of the current contract is mandatory if the estimated annual consumption is specified.',
  pret_furnizare_mwh_rule_number: 'The price of the current contract must be a positive number.',

  compara_preturi_label: 'Compare Prices.',

  pret_furnizare_label: 'Supply price',
  valabilitate_label: 'Availablity',
  cost_anual_actual_label: 'Current annual cost',
  cost_anual_previzionat_label: 'Predicted annual cost',
  procent_label: 'Percent',

  economisiti: 'Save RON{0} annually',
  platiti: 'Pay more with RON {0} per year',

  pret_gaze_naturale_label: 'Natural gas price',
  tarif_transport_label: 'Transport tariff',
  tarif_distributie_label: 'Distribution tariff',
  // termen_plata_label: 'Payment term', // duplicate above
  mod_transmitere_factura_label: 'Invoice Delivery Mode',
  // durata_contractului_label: 'Durata contractului', // duplicate above,
  website_label: 'Website',
  oferta_label: 'Offer',

  data_start_aplicare_label: 'Date from which the offer applies',
  data_start_aplicare_rule_required: 'Date from which the offer applies is mandatory.',

  tip_oferta_label: 'Type of offer',
  tip_oferta_oricare: 'Any',
  tip_oferta_simpla: 'Simple offer',
  tip_oferta_la_pachet: 'Package offer with an Electric Energy offer',
  tip_oferta_rule_required: 'Offer type is mandatory.',
  tip_oferta_rule_in: 'Offer type is invalid.',

  tip_pret_oferta_label: 'Type of natural gas price in the offer',
  tip_pret_oferta_oricare: 'Any',
  tip_pret_oferta_fix: 'Fixed price',
  tip_pret_oferta_variabil: 'Variable price',
  tip_pret_oferta_mixt: 'Mixed price',
  tip_pret_oferta_variabil_spot: 'Variable price based on SPOT prices',
  tip_pret_oferta_variabil_angro: 'Variable price based on WHOLESALE prices',
  tip_pret_oferta_maxim: 'Maximum price',
  tip_pret_oferta_index_variabil: 'Variable price based on a variable Index',
  tip_pret_oferta_required: 'The type of natural gas price in the offer is mandatory.',
  tip_pret_oferta_rule_in: 'Invalid natural gas price type from the offer.',

  suplimentar_componenta_fixa_label: 'Fixed component (subscription) lei/day',
  suplimentar_componenta_fixa_oricare: 'Any',
  suplimentar_componenta_fixa_da: 'yes',
  suplimentar_componenta_fixa_nu: 'no',
  suplimentar_componenta_fixa_required: 'Fixed component (subscription) lei/day is mandatory.',
  suplimentar_componenta_fixa_rule_in: 'The fixed component (subscription) lei/day is invalid.',

  frecventa_emitere_factura_label: 'Frequency of invoice issuance',
  frecventa_emitere_factura_oricare: 'Any',
  frecventa_emitere_factura_lunara: 'monthly',
  frecventa_emitere_factura_2_luni: 'every 2 months',
  frecventa_emitere_factura_3_luni: 'every 3 months',
  frecventa_emitere_factura_required: 'The frequency of issuing the invoice is mandatory.',
  frecventa_emitere_factura_rule_in: 'Frequency of invoice issuance is invalid',

  componenta_fixa_label: 'Enter the fixed component (subscription) from the current bill, if any (lei/day, without VAT)',
  componenta_fixa_hint: 'We recommend that you also fill in this field to obtain comparative information about price and costs in the results table',
  componenta_fixa_rule_number: 'The fixed component must be a positive number.',

  modul_transmitere_factura_label: 'The method of transmission of the invoice',

  documente_client_nou_label: 'New client (new construction, change of owner, etc.)',
  documente_client_furnizor_existent: 'Change of contract conditions (change of contract type, new offer, contract extension, etc.)',
  documente_client_furnizor_nou: 'Change supplier',

  introduceti_pretul_actual: '(enter current price)',
  introduceti_consumul_estimat: '(enter the estimated consumption)',
  introduceti_datele: '(enter data)',
}
